<div class="layout">
  @if (isLoggedIn){
    <!-- Window with timer and option to logout or stay -->
    <app-modal-stay></app-modal-stay>
    <app-side-nav *ngIf="!hide.sideNav" [class]="mainStyle.sideNavOpacity">
    </app-side-nav>
    <div *ngIf="!hide.horNav" class="hor-nav-bar" [class]="mainStyle.sideNavOpacity" [class.no-side-nav]="hide.sideNav">
      <app-horizontal-nav-bar #horNavBar>
      </app-horizontal-nav-bar>
    </div>
  }
  <main [ngStyle]="mainStyle">
    <app-spinner></app-spinner>
    <app-unsaved-changes-modal-wrapper></app-unsaved-changes-modal-wrapper>
    <router-outlet></router-outlet>
  </main>
  <app-notification></app-notification>
</div>
